import { ButtonHTMLAttributes, FC } from 'react'

export const Hamburger: FC<ButtonHTMLAttributes<HTMLButtonElement>> = ({ onClick }) => (
  <button className="flex size-8 flex-col items-end justify-center gap-1 lg:hidden" onClick={onClick}>
    {Array.from({ length: 3 }).map((_, index) => (
      // oxlint-disable-next-line react/no-array-index-key
      <div key={index} className="bg-primary-base h-0.75 w-6 rounded" />
    ))}
  </button>
)
